import React from "react";
import LegalLayout from "@/components/LegalLayout";
import SEOHead from "@/components/SEOHead";

export default function PrivacyPolicy() {
  return (
    <>
      <SEOHead route="privacy" />
      <LegalLayout
        title={
          <>
            Privacy <span className="italic text-[#c01515]">policy.</span>
          </>
        }
        kicker="Legal · 01"
        lastUpdated="29 April 2026"
      >
      <p>
        This Privacy Policy explains how Ranjana Suman Baruah ("we", "our", or
        "us") collects, uses, and protects information you ("you", "the
        visitor") provide when using www.ranjanabaruah.com (the "Site"). By
        using the Site you consent to the practices described below.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        1. What we collect
      </h2>
      <p>
        We only collect information you actively choose to provide via the
        contact form: your <em>name</em>, <em>email address</em>, and the{" "}
        <em>message</em> you submit. We do not request or store payment
        information, government identifiers, or sensitive personal data.
      </p>
      <p>
        Additionally, basic technical information such as IP address, browser
        type, device type, and pages visited may be collected automatically
        through anonymous analytics for the limited purpose of improving the
        Site.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        2. How we use your information
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>To respond to enquiries and collaboration requests.</li>
        <li>To maintain a private record of correspondence.</li>
        <li>To diagnose technical issues and improve user experience.</li>
      </ul>
      <p>
        We do not sell, rent, trade, or share your personal information with
        third parties for marketing purposes.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        3. Cookies and storage
      </h2>
      <p>
        The Site may use small, strictly necessary cookies to keep the
        administrative panel signed in. No advertising or cross-site tracking
        cookies are used. You can disable cookies through your browser, but
        certain non-public areas of the Site may not function without them.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        4. Data retention
      </h2>
      <p>
        Contact form submissions are retained for as long as needed to
        complete the corresponding correspondence, and may be deleted at any
        time on your request via the email address below.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        5. Security
      </h2>
      <p>
        Reasonable technical and organisational measures are taken to protect
        the information you submit, including encrypted transport (HTTPS),
        password-hashing for administrative accounts, and access controls. No
        method of transmission over the internet is 100% secure, however, and
        you provide information at your own risk.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        6. Image rights & likeness
      </h2>
      <p>
        All photographs, portraits, video stills, performance footage, voice
        recordings and any other visual or audio likeness of Ranjana Suman
        Baruah ("the Likeness") published on this Site remain the exclusive
        property of Ranjana Suman Baruah. The Likeness may not be downloaded,
        reproduced, redistributed, modified, used in any compilation,
        magazine, social-media post, advertisement, look-book, mood-board,
        casting database, AI training dataset or generative model, or
        otherwise exploited — in whole or in part, in any form or by any
        means, currently known or hereafter devised — without the express
        prior written consent of Ranjana Suman Baruah.
      </p>
      <p>
        Casting directors, producers and members of the press may request a
        signed image-use grant for a specific publication or production by
        writing to the email address below. Unauthorised use will be treated
        as an infringement of personality and copyright rights and may
        result in legal action.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        7. Your rights
      </h2>
      <p>
        Subject to applicable law, you may request access to, correction of,
        or deletion of personal information we hold about you. You may also
        withdraw consent at any time. Requests can be made by writing to the
        contact below.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        8. Children
      </h2>
      <p>
        The Site is not directed to children under the age of 13 and we do
        not knowingly collect data from them. If you believe a child has
        submitted personal information, please contact us so we can delete
        it.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        9. Changes
      </h2>
      <p>
        This Policy may be updated from time to time. The "Last updated" date
        at the top of this page reflects the most recent revision.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        10. Contact
      </h2>
      <p>
        For any privacy-related questions or requests, including image-rights
        enquiries, please use the contact form on the home page or write to{" "}
        <a
          href="mailto:ranjanabaruah.93@gmail.com"
          className="text-[#c01515] hover:underline"
        >
          ranjanabaruah.93@gmail.com
        </a>
        . The Site Owner is based in <strong>Guwahati, Assam, India</strong>.
      </p>
      </LegalLayout>
    </>
  );
}
